<style scoped>
    iframe {
        border: none;
        width: 100%;
        vertical-align: bottom;
    }
</style>

<template>
    <div>
        <iframe v-if="isShowIframe" id="iframe" ref="iframe" :src="url" @load="resize">
            <p>您的浏览器不支持 iframe 标签,请从列表中下载预览</p>
        </iframe>
        <img :src="url" id="img" v-if="isShowImg">
    </div>
</template>

<script>

    export default {
        name: 'utils_preview',
        data() {
            return {
                url: null,
                isShowIframe: false,
                isShowImg: false,
                //常见图片格式
                imgTypes: ["apng", "avif", "bmp", "ico", "cur", "png", "jpg", "jpeg", "jfif", "pjpeg", "pjp", "svg", "tif", "tiff", "webp", "gif"],
                //office在线预览接口
                officeOnlinePreviewUrl: "https://view.officeapps.live.com/op/view.aspx?src=",
                //office在线预览支持的文件类型
                officePreviewTypes: ["xls", "xlsx", "doc", "docx", "ppt", "pptx"],
                //obs文件（可预览）域名表
                obsUrlStartsWith: []
            }
        },
        async created() {
            await this.getObsServerHost();
            let url = this.$route.query.url;
            let isOfficePreviewType = this.isOfficePreviewType(url);
            let isObsUrl = this.isObsUrl(url);
            let isImg = this.isImg(url);

            if (isImg) {
                let body = document.getElementsByTagName("body")[0];
                body.style.height = window.innerHeight + "px";
                body.style.alignItems = "center";
                body.style.justifyContent = "center";
                body.style.display = "flex";
                this.url = url;
                this.isShowImg = true;
            } else {
                if (isOfficePreviewType && isObsUrl) {
                    url = this.officeOnlinePreviewUrl + url;
                }
                this.url = url;
                this.isShowIframe = true;
            }
            if (isOfficePreviewType && !isObsUrl) {
                //非obs系统（可预览）的office文件直接下载后关闭窗口
                window.open(this.url);
                setTimeout(() =>{
                    window.close();
                } , 300);
            }
        },
        mounted() {
            window.addEventListener('resize', this.resize);
        },
        methods: {
            //根据窗口尺寸设置组件大小
            resize() {
                this.$nextTick(() => {
                    const height = window.innerHeight;
                    const iframe = document.getElementById("iframe");
                    if (iframe) {
                        iframe.style.height = `${height}px`;
                    }
                    const img = document.getElementById("img");
                    if (img) {
                        let body = document.getElementsByTagName("body")[0];
                        body.style.height = `${height}px`;
                    }
                });
            },
            async getObsServerHost(){
                return await this.http.get('/web/customer/files/getObsServerHost').then(response => {
                    this.obsUrlStartsWith = response.data?response.data:[];
                })
            },
            //是否图片
            isImg(url) {
                let suffix = url.substring(0, url.indexOf("?"));
                suffix = suffix.substring(suffix.lastIndexOf(".") + 1);
                return this.imgTypes.contains(suffix);
            },
            //是否office预览文档
            isOfficePreviewType(url) {
                let suffix = url.substring(0, url.indexOf("?"));
                suffix = suffix.substring(suffix.lastIndexOf(".") + 1);
                return this.officePreviewTypes.contains(suffix);
            },
            //是否为OBS链接
            isObsUrl(url) {
                url = decodeURI(url);
                for (let i = 0; i < this.obsUrlStartsWith.length; i++) {
                    if (url.startsWith(this.obsUrlStartsWith[i])) {
                        return true;
                    }
                }
                return false;
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resize);
        },
    }
</script>